import React from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-bg pt-12 pb-20 md:pt-20 md:pb-32 px-4 overflow-hidden" data-id="element-56">
      <div className="max-w-6xl mx-auto" data-id="element-57">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-58">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-59">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-tealLight text-brand-teal text-sm font-bold tracking-wide mb-6" data-id="element-60">
              <ShieldCheck className="w-4 h-4" data-id="element-61" />
              <span data-id="element-62">NUEVO PROTOCOLO 2026</span>
            </div>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-brand-dark leading-tight mb-6" data-id="element-63">
              El "Interruptor de Cortisol": El Protocolo de 48 Horas para Apagar
              la Inflamación Abdominal y el Dolor Articular
            </h1>

            <h2 className="text-xl md:text-2xl text-brand-dark/80 font-medium mb-8 leading-relaxed" data-id="element-64">
              Recupera tu ligereza, deshincha tu vientre y vuelve a moverte sin
              rigidez en solo 2 días (sin fármacos, sin dietas extremas y sin
              suplementos costosos).
            </h2>

            <div className="prose prose-lg text-brand-dark/70 mb-10" data-id="element-65">
              <p className="text-lg leading-relaxed" data-id="element-66">
                Te despiertas un lunes por la mañana y lo primero que sientes es
                esa pesadez familiar. Tus dedos están rígidos, tus rodillas
                protestan al bajar la escalera y, al intentar subir el cierre de
                tu pantalón favorito, confirmas tu peor miedo: no cierra.
              </p>
              <p className="text-lg leading-relaxed font-medium text-brand-dark" data-id="element-67">
                No es falta de voluntad y no es "solo la edad". Es un incendio
                biológico interno que nadie te ha enseñado a apagar.
              </p>
            </div>

            <button onClick={scrollToPricing} className="w-full sm:w-auto flex items-center justify-center gap-3 bg-brand-amber hover:bg-brand-amberHover text-white text-xl font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-68">
              QUIERO DESINFLAMARME AHORA
              <ArrowRight className="w-6 h-6" data-id="element-69" />
            </button>
            <p className="mt-4 text-sm text-brand-dark/60 flex items-center justify-center sm:justify-start gap-2" data-id="element-70">
              <ShieldCheck className="w-4 h-4" data-id="element-71" />
              Garantía de satisfacción de 7 días
            </p>
          </div>

          {/* Image Content */}
          <div className="relative" data-id="element-72">
            <div className="absolute inset-0 bg-brand-teal/10 rounded-full blur-3xl transform scale-110" data-id="element-73"></div>
            <img src="https://cdn.magicpatterns.com/uploads/srub4mGa53YxJZtW8hUNG4/heylloyd-image-1773201884798.png" alt="Protocolo Anti-Inflamación 48H en múltiples dispositivos" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-2xl" data-id="element-74" />
          </div>
        </div>
      </div>
    </section>;
}